export function toNumberOrNull(value: unknown): number | null | undefined {
  if (value === undefined) {
    return undefined;
  }

  if (value === null || value === '') {
    return null;
  }

  if (typeof value === 'number') {
    return Number.isNaN(value) ? null : value;
  }

  const numericValue = Number(value);
  return Number.isNaN(numericValue) ? null : numericValue;
}
